var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24C8.89375 24 8 23.1063 8 22V4C8 2.89375 8.89375 2 10 2H19V7C19 8.10625 19.8937 9 21 9H26C26 9.01875 26 9.03125 26 9.05V22C26 23.1063 25.1063 24 24 24H10ZM21 3.59375L24.375 7H21V3.59375ZM10 0C7.79375 0 6 1.79375 6 4V22C6 24.2062 7.79375 26 10 26H24C26.2062 26 28 24.2062 28 22V9.05C28 8.25625 27.6875 7.5 27.1313 6.9375L21.1313 0.8875C20.5688 0.31875 19.8 0 19 0H10ZM2 7C2 6.45 1.55 6 1 6C0.45 6 0 6.45 0 7V24C0 28.4188 3.58125 32 8 32H21C21.55 32 22 31.55 22 31C22 30.45 21.55 30 21 30H8C4.6875 30 2 27.3125 2 24V7Z",
    fill: "#2A00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.77ee1b6818d92db936e7b3631e66a896.svg";
export { ForwardRef as ReactComponent };